export const intersection = <T>(...arrays: T[][]): T[] => {
    return arrays.reduce((a, b) => a.filter((c) => b.includes(c)));
};
export const intersection = <T>(...arrays: T[][]): T[] => {
    return arrays.reduce((a, b) => a.filter((c) => b.includes(c)));
};
